import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './style.sass'
import styles from "./ModulosPagarPlanes/pagarPlan.module.sass"

import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64'
import { ModalError } from 'components/Error/ErrorModal'
import Loading from 'components/Loading'
import { Error500 } from 'components/Error/Error500'
import { usePlanesPago } from './ModulosPagarPlanes'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import PagarTarjetaDesktop from './Desktop'
import PagarTarjetaMovil from './Movil'


export default function PagarTarjeta() {

    const {
        singlePlanData,
        completePlanData,
        showModal,
        errorCode,
        isMobile,
        setErrorCode,
        handleClose
    } = usePlanesPago()

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Card Payment Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    }, [])

    const history = useHistory()
    const [loading, setLoading] = useState(true)

    const clickToPay = decodeStorage('clickToPay')
    const lastConsultData = decodeStorage('lastConsultData')


    useEffect(()=>{     
        if(clickToPay === "PagarPlan"){
            setLoading(true)
            setTimeout(() => {
                paySimplePlan('replace')
            }, 1000)
        }
        else if(clickToPay === "ElegirPlan" ){
            setLoading(false)
        }
        else if(clickToPay === ""){
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`)
        }
    },[clickToPay])

    let dataAcount = {
        account_number: lastConsultData[0]?.account_number,
        cardending: lastConsultData[0]?.cards[0]?.card_number.substr(-4),
        card: lastConsultData[0]?.cards[0]?.card_number
    }

    // remueve el plan actual
    useEffect(() => {
        removeStorage('payCardRelation')
        removeStorage('payCodeSuccess')

    }, [])

    // funcion para pagar plan simple
    const paySimplePlan = (urlType) => {
        if(document.querySelector(`.${styles?.contentCardsSimplePlan}  input[type="radio"]:checked`)){
            let valorPlan = document.querySelector(`.${styles?.contentCardsSimplePlan}  input[type="radio"]:checked`).value;
            let valorTerminal = document.querySelector(`.${styles?.contentCardsSimplePlan}  input[type="radio"]:checked`).dataset.terminal;

            if (valorPlan >= 1) {
                payPlans(valorPlan, "single", '', valorTerminal, urlType);
            } else {
                setVerModalMontoMinimo(true);
                setErrorCode({ "codMen": 'ER0PAY0' });
            }
        }
    }


    // funcion generar bloque de pago
    const payPlans = (valorPlan, tipoPlan, arrayPlan, terminal, typeURL) => {
        let totalToPay = Number(valorPlan)
        let planPagoGral = []

        if (tipoPlan === "single") {
            planPagoGral.push({
                plan: 0,
                sequence: 0,
                amount: totalToPay
            })
        } else if (tipoPlan === "multi") {
            planPagoGral = arrayPlan
        }

        let payCardRelation = {
            'totalToPay': totalToPay,
            'planPagoGral': planPagoGral,
            'dataAcount': dataAcount,
            'terminal': terminal
        }
        encodeStorage('payCardRelation', payCardRelation)
        setLoading(false)

        if(typeURL === 'replace'){
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
        }else{
            history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/elegir-tarjeta`)
        }
    }

    const [verModalMontoMinimo, setVerModalMontoMinimo] = useState(false);
    const cerrarModalMontoMinimo = () => {
        if (verModalMontoMinimo) {
            setVerModalMontoMinimo(false);
        }
    }


    return (
        <>
            {loading && <Loading />}

            {errorCode >= 500
                ? 
                    <Error500 />
                :
                    isMobile
                        ? isMobile === 'desktop'
                            ?
                                <PagarTarjetaDesktop
                                    singlePlanData={singlePlanData}
                                    completePlanData={completePlanData}
                                    isMobile={isMobile}
                                    setLoading={setLoading}
                                    verModalMontoMinimo={verModalMontoMinimo}
                                    paySimplePlan={paySimplePlan}
                                    cerrarModalMontoMinimo={cerrarModalMontoMinimo}
                                />
                            :
                                <PagarTarjetaMovil
                                    singlePlanData={singlePlanData}
                                    completePlanData={completePlanData}
                                    isMobile={isMobile}
                                    setLoading={setLoading}
                                    verModalMontoMinimo={verModalMontoMinimo}
                                    paySimplePlan={paySimplePlan}
                                    cerrarModalMontoMinimo={cerrarModalMontoMinimo}
                                />
                        : null
                }

            {showModal && errorCode <= 499 &&
                <ModalError errorCode={errorCode} handleClose={handleClose} />
            }

        </>
    )
}